// @flow
import React, {Component} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import theme from '../../theme-config';

const hiddenInputStyle = {
  position: 'absolute',
  opacity: 0,
  height: 1,
  width: 1,
  pointerEvents: 'none',
};

export default class DigitsInput extends Component {
  inputRef = React.createRef();

  focusInput = () => this.inputRef.current?.focus();

  handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, this.props.maxLength || 4);
    this.props.input.onChange(val);
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter' && this.props.onSubmitEditing) {
      this.props.onSubmitEditing();
    }
  };

  render() {
    const {input, meta, maxLength = 4, autoFocus, style} = this.props;
    const value = input.value || '';
    const digits = Array.from({length: maxLength});

    return (
      <View style={[styles.container, style]}>
        <Pressable onPress={this.focusInput}>
          <View style={styles.row}>
            {digits.map((_, i) => {
              const isCurrent = i === value.length && meta.active;
              const isFilled = i < value.length;
              return (
                <View
                  key={i}
                  style={[
                    styles.digitBox,
                    (isCurrent || isFilled) && styles.activeDigitBox,
                  ]}>
                  <Text style={styles.digitText}>{value[i] || ''}</Text>
                </View>
              );
            })}
          </View>
        </Pressable>
        <input
          ref={this.inputRef}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={this.handleChange}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          onKeyDown={this.handleKeyDown}
          autoFocus={autoFocus}
          maxLength={maxLength}
          style={hiddenInputStyle}
        />
        {meta.touched && meta.error && (
          <Text style={styles.error}>{meta.error}</Text>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    position: 'relative',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 8,
  },
  digitBox: {
    width: 50,
    height: 60,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: theme.digitsInputColor,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeDigitBox: {
    borderColor: theme.secondaryColor,
    borderWidth: 2,
  },
  digitText: {
    color: theme.digitsInputColor,
    fontSize: 28,
    fontWeight: '600',
    textAlign: 'center',
  },
  error: {
    color: theme.primaryColor,
    textAlign: 'center',
    marginTop: 8,
    fontSize: 14,
  },
});
